export default "__VITE_ASSET__CgB4q119__"